<script setup lang="ts">
import { useOptionalBaseMap } from '@/composables/scopedStores/map/useBaseMap'
import { TBannerVariant } from '@lifk/types'
import { PhCursor } from '@phosphor-icons/vue'
import { computed } from 'vue'

withDefaults(
  defineProps<{
    /** What text should be displayed in the banner? */
    text?: string
    /** What variant of the banner should be used? */
    variant?: TBannerVariant
    /** What icon should be displayed in the banner? */
    icon?: keyof typeof iconMapping
    /** Override Max Width */
    maxWidth?: string
  }>(),
  {
    variant: 'default',
    maxWidth: '560px'
  }
)

const baseMapStore = useOptionalBaseMap()

const variantMapping = computed(() => ({
  default: `${
    baseMapStore?.baseMapStyle.value === 'satellite'
      ? 'bg-default text-default'
      : 'bg-inverse text-inverse'
  }`,
  stone: 'bg-default text-default',
  white: 'bg-elevated text-default',
  warning: 'bg-warning text-emphasis',
  slate: 'bg-inverse text-inverse',
  error: 'bg-error text-inverse',
  success: 'bg-success text-inverse'
}))

const iconMapping = {
  Cursor: PhCursor
}
</script>

<template>
  <div
    class="w-fit max-w-[var(--max-width)] mx-auto shadow rounded-small py-[10px] px-5 font-medium text-center text-body"
    :class="variantMapping[variant]"
    :style="{ '--max-width': maxWidth }"
    v-bind="$attrs"
  >
    <slot>
      <div v-if="text" class="flex items-center justify-center gap-[10px]">
        <component
          :is="iconMapping[icon]"
          v-if="icon"
          class="inline-block w-6 h-6"
        ></component>
        {{ text }}
      </div>
    </slot>
  </div>
</template>
